// extracted by mini-css-extract-plugin
export default {"container":"AboutUsFully_container__D+Wz1"};